export const Data = [
  {
    type: "zh",
    imgBoxUrl:"https://www.victrum.com/image/tp/关于我们banner.png",
    numList : [
      {
        num : "1",
        tital : "公司简介",
        path: "ggjj"
      },
      {
        num : "2",
        tital : "发展历程",
        path: "fzlc"
      },
      {
        num : "3",
        tital : "核心优势",
        path: "hxys"
      },
      // {
      //   num : "4",
      //   tital : "团队成员",
      //   path: "tdcy"
      // },
      {
        num : "5",
        tital : "愿景使命",
        path: "yjsm"
      }
    ],
    pptext:{
      text1 : "公司简介",
      text2 : "微创未来（北京）激光技术有限公司成立于2014年，在口腔激光领域拥有丰富经验和领先技术。公司为国家级高新技术企业，目前拥有北京、苏州两个生产基地，具备丰富的技术储备，专注于全线口腔激光治疗设备和配套耗材的研发、生产和商业化。",
      text3: "2024年3月21日，微创未来旗舰产品VICTRUM口腔Er:YAG激光治疗仪正式取得NMPA第三类医疗器械注册证（注册编码：20243010581），正式在国内上市，成为国产口腔铒激光治疗设备，填补了国内口腔铒激光产品的市场空白。 \n" +
        "微创未来口腔铒激光于2022年10月在首都医科大学宣武医院和中日友好医院共同完成了临床试验。公司研发团队由北大口腔、上海交通大学、军工激光专家团队高端人才组成。公司突破技术封锁，拥有完善的自主知识产权布局，已取得八十项以上的相关专利，产品技术处于国际领先地位。\n" +
        "公司拥有完善的全国售前和售后服务体系，设立大区域服务中心，为各区域口腔医生提供完善的临床技术支持和售后服务。 \n" +
        "微创未来VICTRUM口腔铒激光为牙科激光领域带来了革命性的变革，就像移动手机让世界摆脱了传统电话线的束缚一样。 “手柄内置激光”技术，彻底解决了市场中通过光纤或关节臂传输的Er:YAG激光所一直无法解决的技术难题，例如，设备体积大，传输能量损失大，操作不便，售后维修成本高昂等一系列问题。从而能够加快口腔铒激光的普及，让医生像使用高速涡轮手机一样操作激光。"
    },
    cpbuLsit : [
      {
        text1 : "10",
        text2 : "TH",
        text3: "成立于2014年"
      },
      {
        text1 : "80",
        text2 : "+",
        text3: "80多项知识产权"
      },
      // {
      //   text1 : "10",
      //   text2 : "+",
      //   text3: "10多个出口国家"
      // },
      {
        text1 : "20",
        text2 : "+",
        text3: "核心研发工程师"
      }
    ],
    c2DataList : [
      {
        text1:"2014",
        text2:"公司成立,同时立项开发Er:YAG口腔激光治疗仪",
        text3:"",
        url:""
      },
      {
        text1:"2017",
        text2:"国产口腔Er:YAG激光治疗仪模拟机完成",
        text3:"",
        url:""
      },
      {
        text1:"2019",
        text2:"国产口腔Er:YAG激光治疗仪功能机完成",
        text3:"",
        url:""
      },
      {
        text1:"2020",
        text2:"国产口腔Er:YAG激光治疗仪样机完成国家型式检验",
        text3:"",
        url:""
      },
      {
        text1:"2021年4月",
        text2:"通过首都医科大学宣武医院伦理委员会审查",
        text3:"",
        url:""
      },
      {
        text1:"2022年10月",
        text2:"口腔Er:YAG激光治疗仪完成临床试验",
        text3:"",
        url:""
      },
      {
        text1:"2023年2月",
        text2:"口腔Er:YAG激光治疗仪取得药监局受理通知书",
        text3:"",
        url:""
      },
      {
        text1:"2024年3月22日",
        text2:"取得国内首张口腔Er:YAG激光治疗仪NMPA注册证",
        text3:"",
        url:""
      },
      {
        text1:"2024年6月",
        text2:"参与“无光纤传输技术Er:YAG激光口腔临床应用规范”行标的建立",
        text3:"",
        url:""
      }
    ],
    c3Data:{
      c3P:[
        {
          text1:"· 高端器械，中国智造"
        },
        {
          text1:"· 国产口腔Er:YAG激光治疗仪"
        },
        {
          text1:"· 因其独创“激光器内置激光手柄内”专利，既无高昂易损的光纤件，也彻底改良了笨重的关节臂传导光系统"
        }

      ],
      c3w:[
        {text1 : "80",
          text2 : "+",
          text3: "知识产权"},
        {
          text1 : "20",
          text2 : "+",
          text3: "核心研发工程师"
        }
        // ,
        // {
        //   text1 : "10",
        //   text2 : "+",
        //   text3: "10多个出口国家"
        // },
        // {text1 : "10",
        //   text2 : "+",
        //   text3: "10多个出口国家"}
      ],
      c3Img:[
        {
          imgItem:[
            {
              url:"https://www.victrum.com/image/nr/gywm/1.png",
              text1:""
            },
            {
              url:"https://www.victrum.com/image/nr/gywm/2.png",
              text1:""
            },
            {
              url:"https://www.victrum.com/image/nr/gywm/3.png",
              text1:""
            }
          ]
        },
        {
          imgItem:[
            {
              url:"https://www.victrum.com/image/nr/gywm/4.jpg",
              text1:""
            },
            {
              url:"https://www.victrum.com/image/nr/gywm/5.png",
              text1:""
            },
            {
              url:"https://www.victrum.com/image/nr/gywm/6.png",
              text1:""
            }
          ]
        }
      ]
    },
    c4Data:[
      {
        imgUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        text1:"张三",
        text2:"XX自2012年2月起担任CASI公司董事会主席，2018年2月起担任董事会执行主席，从2019年起兼任首席执行官。加入XX之前，XXX科技有限公司董事会主席兼首席执行官",
        text3:"XXX博士是ETP基金创始人、合伙人，ETP是一家专注于生命科学领域的风险投资公司，成立于2000年。在职业生涯中，何博士创立或投资了超过100余家生物技术公司，其中包括数家独角兽企业。",
        text4:"在职业生涯的早期，XXX是人类基因编组的首批科学家。在此之前他曾在哈佛麻省总院和梅奥医学中心做博士后研究。发表了超过30篇研究文献，并且是32项专利的发明人。他拥有贝勒医学院分子生物学博士，并获得沃顿商学院的MBA学位。"
      },
      {
        imgUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        text1:"李四",
        text2:"XX自2012年2月起担任CASI公司董事会主席，2018年2月起担任董事会执行主席，从2019年起兼任首席执行官。加入XX之前，XXX科技有限公司董事会主席兼首席执行官",
        text3:"XXX博士是ETP基金创始人、合伙人，ETP是一家专注于生命科学领域的风险投资公司，成立于2000年。在职业生涯中，何博士创立或投资了超过100余家生物技术公司，其中包括数家独角兽企业。",
        text4:"在职业生涯的早期，XXX是人类基因编组的首批科学家。在此之前他曾在哈佛麻省总院和梅奥医学中心做博士后研究。发表了超过30篇研究文献，并且是32项专利的发明人。他拥有贝勒医学院分子生物学博士，并获得沃顿商学院的MBA学位。"
      },
      {
        imgUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        text1:"李四",
        text2:"XX自2012年2月起担任CASI公司董事会主席，2018年2月起担任董事会执行主席，从2019年起兼任首席执行官。加入XX之前，XXX科技有限公司董事会主席兼首席执行官",
        text3:"XXX博士是ETP基金创始人、合伙人，ETP是一家专注于生命科学领域的风险投资公司，成立于2000年。在职业生涯中，何博士创立或投资了超过100余家生物技术公司，其中包括数家独角兽企业。",
        text4:"在职业生涯的早期，XXX是人类基因编组的首批科学家。在此之前他曾在哈佛麻省总院和梅奥医学中心做博士后研究。发表了超过30篇研究文献，并且是32项专利的发明人。他拥有贝勒医学院分子生物学博士，并获得沃顿商学院的MBA学位。"
      },
      {
        imgUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        text1:"李四",
        text2:"XX自2012年2月起担任CASI公司董事会主席，2018年2月起担任董事会执行主席，从2019年起兼任首席执行官。加入XX之前，XXX科技有限公司董事会主席兼首席执行官",
        text3:"XXX博士是ETP基金创始人、合伙人，ETP是一家专注于生命科学领域的风险投资公司，成立于2000年。在职业生涯中，何博士创立或投资了超过100余家生物技术公司，其中包括数家独角兽企业。",
        text4:"在职业生涯的早期，XXX是人类基因编组的首批科学家。在此之前他曾在哈佛麻省总院和梅奥医学中心做博士后研究。发表了超过30篇研究文献，并且是32项专利的发明人。他拥有贝勒医学院分子生物学博士，并获得沃顿商学院的MBA学位。"
      }

    ],
    c5Data:[
      {
        text1:"企业愿景",
        text2: "成为口腔激光产品的全球领导品牌"
      },
      {
        text1:"企业使命",
        text2: "帮患者看牙舒适不恐惧，助医生治牙安全又高效"
      },
      {
        text1:"企业价值观",
        text2: "超越客户期望，成就核心员工"
      }
    ]
  },
  {
    type: "en",
    imgBoxUrl:"https://www.victrum.com/image/tp/关于我们banner.png",
    numList : [
      {
        num : "1",
        tital : "Company Profile",
        path: "ggjj"
      },
      {
        num : "2",
        tital : "Development History",
        path: "fzlc"
      },
      {
        num : "3",
        tital : "Core Advantages",
        path: "hxys"
      },
      // {
      //   num : "4",
      //   tital : "团队成员",
      //   path: "tdcy"
      // },
      {
        num : "5",
        tital : "Vision & Mission",
        path: "yjsm"
      }
    ],
    pptext:{
      text1 : "Company Profile",
      text2 : "Micro-Innovation (Beijing) Laser Technology Co., Ltd., established in 2014, brings a wealth of experience and cutting-edge technology to the field of dental lasers. As a national high-tech enterprise, the company operates two production bases in Beijing and Suzhou, with extensive technological resources focused on the research, development, production, and commercialization of a full range of dental laser treatment devices and consumables.",
      text3: "On March 21, 2024, Micro-Innovation's flagship product, the VICTRUM Er:YAG Laser System, officially received the NMPA Class III Medical Device Registration Certificate (Registration Code: 20243010581), marking its domestic market debut as China's first Erdental laser device. This milestone fills a significant gap in the Chinese dental laser market.\n" +
        "The clinical trials for the VICTRUM Er:YAG Laser were successfully completed in October 2022 at Capital Medical University Xuanwu Hospital and the China-Japan Friendship Hospital. The company's R&D team consists of top-tier talent from institutions such as Peking University School of Stomatology, Shanghai Jiao Tong University, and military laser experts. Micro-Innovation has overcome significant technological barriers, establishing a comprehensive intellectual property portfolio with over 80 related patents, placing its product technology at the forefront of the global market.\n" +
        "The company also boasts a nationwide pre-sales and after-sales service network, with major regional service centers that provide comprehensive clinical technical support and maintenance services to dental professionals across China.\n" +
        "The VICTRUM Er:YAG Laser represents a revolutionary advancement in dental laser technology, much like how mobile phones freed the world from traditional landlines. The \"laser-in-handle\" technology solves the persistent technical challenges associated with  Er:YAG lasers that rely on fiber or articulated arms, such as large device size, energy transmission loss, operational inconvenience, and high maintenance costs. This breakthrough paves the way for widespread adoption of  Er:YAG lasers, enabling dentists to operate the laser with the ease and familiarity of a high-speed turbine handpiece."
    },
    cpbuLsit : [
      {
        text1 : "10",
        text2 : "TH",
        text3: "Established in 2014"
      },
      {
        text1 : "80",
        text2 : "+",
        text3: "Intellectual Property Rights"
      },
      // {
      //   text1 : "10",
      //   text2 : "+",
      //   text3: "10多个出口国家"
      // },
      {
        text1 : "20",
        text2 : "+",
        text3: "Core R&D Engineers"
      }
    ],
    c2DataList : [
      {
        text1:"2014",
        text2:"the company was established and initiated the development of the Er:YAG dental laser treatment system.",
        text3:"",
        url:""
      },
      {
        text1:"2017",
        text2:"the first domestic simulation model of the Er:YAG dental laser treatment system was completed.",
        text3:"",
        url:""
      },
      {
        text1:"2019",
        text2:"the first functional model of the domestic Er:YAG dental laser treatment system was completed.",
        text3:"",
        url:""
      },
      {
        text1:"2020",
        text2:"the prototype of the first domestic Er:YAG dental laser treatment system passed the national type inspection.",
        text3:"",
        url:""
      },
      {
        text1:"April 2021",
        text2:"the Er:YAG dental laser passed the ethics review of the Capital Medical University Xuanwu Hospital.",
        text3:"",
        url:""
      },
      {
        text1:"October 2022",
        text2:"the clinical trials for the Er:YAG dental laser treatment system were completed.",
        text3:"",
        url:""
      },
      {
        text1:"February 2023",
        text2:"the Er:YAG dental laser treatment system received the acceptance notice from the National Medical Products Administration (NMPA).",
        text3:"",
        url:""
      },
      {
        text1:"March 22, 2024",
        text2:"the first domestic NMPA registration certificate for the Er:YAG dental laser treatment system was issued.",
        text3:"",
        url:""
      },
      {
        text1:"June 2024",
        text2:"the company participated in establishing the industry standard for \"Fiber-Free Transmission Technology in Er:YAG Laser Clinical Applications.",
        text3:"",
        url:""
      }
    ],
    c3Data:{
      c3P:[
        {
          text1:"· High-end Equipment, Made in China"
        },
        {
          text1:"· The first domestic Er:YAG dental laser treatment system."
        },
        {
          text1:"· Innovative \"Laser-in-Handle\" Technology: This patented design eliminates expensive and fragile fiber optics and significantly improves the articulated arm laser transmission system."
        }

      ],
      c3w:[
        {text1 : "80",
          text2 : "+",
          text3: "Intellectual Property Rights"},
        {
          text1 : "20",
          text2 : "+",
          text3: "Core R&D Engineers"
        }
        // ,
        // {
        //   text1 : "10",
        //   text2 : "+",
        //   text3: "10多个出口国家"
        // },
        // {text1 : "10",
        //   text2 : "+",
        //   text3: "10多个出口国家"}
      ],
      c3Img:[
        {
          imgItem:[
            {
              url:"https://www.victrum.com/image/nr/gywm/1.png",
              text1:""
            },
            {
              url:"https://www.victrum.com/image/nr/gywm/2.png",
              text1:""
            },
            {
              url:"https://www.victrum.com/image/nr/gywm/3.png",
              text1:""
            }
          ]
        },
        {
          imgItem:[
            {
              url:"https://www.victrum.com/image/nr/gywm/4.jpg",
              text1:""
            },
            {
              url:"https://www.victrum.com/image/nr/gywm/5.png",
              text1:""
            },
            {
              url:"https://www.victrum.com/image/nr/gywm/6.png",
              text1:""
            }
          ]
        }
      ]
    },
    c4Data:[
      {
        imgUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        text1:"张三",
        text2:"XX自2012年2月起担任CASI公司董事会主席，2018年2月起担任董事会执行主席，从2019年起兼任首席执行官。加入XX之前，XXX科技有限公司董事会主席兼首席执行官",
        text3:"XXX博士是ETP基金创始人、合伙人，ETP是一家专注于生命科学领域的风险投资公司，成立于2000年。在职业生涯中，何博士创立或投资了超过100余家生物技术公司，其中包括数家独角兽企业。",
        text4:"在职业生涯的早期，XXX是人类基因编组的首批科学家。在此之前他曾在哈佛麻省总院和梅奥医学中心做博士后研究。发表了超过30篇研究文献，并且是32项专利的发明人。他拥有贝勒医学院分子生物学博士，并获得沃顿商学院的MBA学位。"
      },
      {
        imgUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        text1:"李四",
        text2:"XX自2012年2月起担任CASI公司董事会主席，2018年2月起担任董事会执行主席，从2019年起兼任首席执行官。加入XX之前，XXX科技有限公司董事会主席兼首席执行官",
        text3:"XXX博士是ETP基金创始人、合伙人，ETP是一家专注于生命科学领域的风险投资公司，成立于2000年。在职业生涯中，何博士创立或投资了超过100余家生物技术公司，其中包括数家独角兽企业。",
        text4:"在职业生涯的早期，XXX是人类基因编组的首批科学家。在此之前他曾在哈佛麻省总院和梅奥医学中心做博士后研究。发表了超过30篇研究文献，并且是32项专利的发明人。他拥有贝勒医学院分子生物学博士，并获得沃顿商学院的MBA学位。"
      },
      {
        imgUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        text1:"李四",
        text2:"XX自2012年2月起担任CASI公司董事会主席，2018年2月起担任董事会执行主席，从2019年起兼任首席执行官。加入XX之前，XXX科技有限公司董事会主席兼首席执行官",
        text3:"XXX博士是ETP基金创始人、合伙人，ETP是一家专注于生命科学领域的风险投资公司，成立于2000年。在职业生涯中，何博士创立或投资了超过100余家生物技术公司，其中包括数家独角兽企业。",
        text4:"在职业生涯的早期，XXX是人类基因编组的首批科学家。在此之前他曾在哈佛麻省总院和梅奥医学中心做博士后研究。发表了超过30篇研究文献，并且是32项专利的发明人。他拥有贝勒医学院分子生物学博士，并获得沃顿商学院的MBA学位。"
      },
      {
        imgUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        text1:"李四",
        text2:"XX自2012年2月起担任CASI公司董事会主席，2018年2月起担任董事会执行主席，从2019年起兼任首席执行官。加入XX之前，XXX科技有限公司董事会主席兼首席执行官",
        text3:"XXX博士是ETP基金创始人、合伙人，ETP是一家专注于生命科学领域的风险投资公司，成立于2000年。在职业生涯中，何博士创立或投资了超过100余家生物技术公司，其中包括数家独角兽企业。",
        text4:"在职业生涯的早期，XXX是人类基因编组的首批科学家。在此之前他曾在哈佛麻省总院和梅奥医学中心做博士后研究。发表了超过30篇研究文献，并且是32项专利的发明人。他拥有贝勒医学院分子生物学博士，并获得沃顿商学院的MBA学位。"
      }

    ],
    c5Data:[
      {
        text1:"Corporate Vision",
        text2: "To become the global leader in dental laser products."
      },
      {
        text1:"Corporate Mission",
        text2: "To provide patients with comfortable, fear-free dental care and help doctors deliver safe and efficient treatments."
      },
      {
        text1:"Corporate Values",
        text2: "Exceed customer expectations and empower core employees."
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/js/aboutUs.js